<template>
    <!-- Modal -->
    <div class="modal" id="roomCancelModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">객실 예약 취소</h4>
                    <button type="button" class="btn btn-m flat btn-close" data-dismiss="modal" aria-label="Close">
                        <i class="icon-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="text-center mt-40">
                        <b>해당 이용객의 객실을 취소하시겠습니까?</b>
                    </p>
                    <p class="text-center text-666 mt-15">{{selectedCalcelBooking.roomGuest.visitor.visitorName}} / {{selectedCalcelBooking.roomGuest.visitor.visitorCompany}}<br />
                        {{ getDateString(selectedCalcelBooking.fromDate) }} ~ {{getDateString(selectedCalcelBooking.toDate)}}
                    </p>
                    <hr style="width:auto; margin:20px -20px;background-color:#e2e2e2;">
                    <p class="text-light-blue">
                        <i class="icon-dot mr-5"></i>예약확정 상태의 객실 취소 시, 방문객에게 이메일로 통보됩니다.</p>
                    <div class="btn-wrap justify-content-center mt-20 mb-40">
                        <button class="btn btn-lg line-2" data-dismiss="modal" aria-label="Close">
                            <i class="icon-close mr-5"></i>취소</button>
                        <button class="btn btn-lg danger" data-dismiss="modal" aria-label="Close" @click="submit()">
                            <i class="icon-check mr-5"></i>예약취소</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RoomCalcelModal",
        props: ['selectedCalcelBooking'],
        data() {
            return {
            }
        },
        watch: {
        },
        mounted(){

        },
        methods: {
            submit(){
                let param = {
                    bookingId: this.selectedCalcelBooking.bookingId,
                    visitorId: this.selectedCalcelBooking.roomGuest.visitorId
                };
                this.$http.post('/api/private/booking/cancel/booking', param)
                    .then((result) => {
                        this.noti('완료', '예약이 취소되었습니다.', 'success');
                        this.$emit('init');
                    }).catch((e) =>{
                    console.log(e);
                })
            },
            getDateString(timestamp){
                return moment.unix(timestamp/1000).format('YYYY년 MM월 DD일')
            },
        }
    }
</script>

<style scoped>

</style>